import { strRegistrationApiSender } from '../utils/str-registration-api-sender';
import { CardNumberElement } from '@stripe/react-stripe-js';
export async function payCC(params) {
  const {
    stripe,
    elements,
    paymentPayload,
    onSuccessRedirect,
    onSuccess,
    unlock,
    // setLoading,
    // history,
    onError,
  } = params;

  if (!stripe || !elements) {
    onError('No stripe or no elements')
  }

  try {
    const { data: { clientSecret } } = await strRegistrationApiSender.post('/payCC', {
      ...paymentPayload,
    });

    const result = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: elements.getElement(CardNumberElement),
        billing_details: { name: paymentPayload.signatory },
      },
      receipt_email: paymentPayload.userEmail,
    });

    if (result.error) {
      onError(result.error);
      // TODO: Show error to customer (e.g., insufficient funds)
      unlock();
      alert(result.error.message);
    } else if (result.paymentIntent.status === 'succeeded') {
      console.log('success');
      await onSuccess();
      await onSuccessRedirect();
    }
  } catch (err) {
    console.log('err', err);
    onError(err);
    unlock();
  }
}
